<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>

    <Filters />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Filters from "../../components/Workflow/Definitions/Filters.vue";
export default {
  components: { LandingToolbar, Filters },
};
</script>
